import { useContext } from "react";
import SettingsResourceScheduleAdminContext from "./SettingsResourceScheduleAdminContext";

const useSettingsResourceScheduleAdminContext = () => {
    return useContext(SettingsResourceScheduleAdminContext);
}

export default useSettingsResourceScheduleAdminContext;